import React, { useMemo } from 'react'
import qs from 'qs'
import Uppy from '@uppy/core'
import { DragDrop } from '@uppy/react'
import '@uppy/core/dist/style.css'
import '@uppy/drag-drop/dist/style.css'
import { getAppIdFromURL } from '@vt/utils'
import { css } from '@emotion/css'
import { imgAudioVideo } from '../../../utils/file-constants'
import addImg from '../assets/add.png'
import uploadingImg from '../assets/uploading.png'

const UploadFile = ({
  opts,
  files: currentFiles,
  selectedfiles,
  updateSelectedfiles,
  uploadStatus,
  updateUploadStatus,
  onClickUpload,
}) => {
  const {
    slug,
    allowedTypes,
    maxSize,
    uploadQuantities,
    allowedWebImport = true,
  } = opts

  // uppy所允许的上传类型（需判断图音频是否允许导入）
  const alloweType = allowedWebImport
    ? allowedTypes
    : (allowedTypes || []).filter((v) => imgAudioVideo.indexOf(v) === -1)
  const uppy = new Uppy({
    id: slug + '-dragDrop',
    allowMultipleUploadBatches: true,
    restrictions: {
      maxNumberOfFiles: uploadQuantities || null,
      minNumberOfFiles: 1,
      allowedFileTypes: alloweType,
    },
    debug: true,
  })

  const extInfo = useMemo(() => {
    return opts.slug === 'picture' && currentFiles.length
      ? currentFiles[currentFiles.length - 1].extInfo
      : {}
  }, [])

  const upload = (files) => {
    const formData = new FormData()
    const newFiles = []
    // const names = []
    files.forEach((v) => {
      if (v.data) {
        formData.append('files', v.data)
        newFiles.push(v)
        // names.push(v.name)
      }
    })

    formData.append('appId', getAppIdFromURL() || '957')
    // formData.append('customFileNames', names)
    if (onClickUpload) {
      onClickUpload(formData)
        .then((data) => {
          const filesData = (data && data.data) || []
          const arr = []
          const time = Date.now()
          filesData.forEach((obj, index) => {
            if (obj) {
              const [llink, queries] = obj.llink.split('?')
              // 大连，现场检查图片
              // const extInfo =
              //   opts.slug === 'picture'
              //     ? {
              //         address: getValues('lnglat_text'),
              //         lnglat: getValues('lnglat') || [],
              //         catchTime: time,
              //       }
              //     : {}
              // const extInfo =
              //   opts.slug === 'picture' && currentFiles.length
              //     ? currentFiles[currentFiles.length - 1].extInfo
              //     : {}

              const currentFile = {
                filename:
                  obj.extendedData && obj.extendedData.originalName
                    ? obj.extendedData.originalName
                    : '',
                name: obj.name,
                src: llink,
                urlSuffixMap: queries && qs.parse(queries),
                fileType: newFiles[index].extension,
                time,
                extInfo,
              }
              arr.push(currentFile)
            }
          })

          updateSelectedfiles(
            // time 上传时间
            arr.concat(selectedfiles)
          )
          updateUploadStatus('success')
        })
        .catch(() => {
          updateUploadStatus('error')
        })
    }
  }

  uppy.on('files-added', (files) => {
    console.log(files, '选择的文件')
    const arr = []
    files.forEach((file) => {
      if (maxSize && file.size > maxSize * 1024 * 1024) {
        console.log('大小超出')
        updateUploadStatus('size-over')
      } else if (
        uploadQuantities &&
        selectedfiles.length === uploadQuantities
      ) {
        console.log('个数限制')
        updateUploadStatus('limit')
      } else {
        arr.push(file)
        updateUploadStatus('loading')
      }
    })
    console.log('可上传的文件', files)
    if (arr.length > 0) {
      upload(arr)
    }
  })

  // 上传状态(暂时未用)
  // eslint-disable-next-line no-unused-vars
  const renderStatus = (status) => {
    if (status === 'loading') {
      return (
        <>
          <img
            alt=""
            className="status-icon cursor-pointer mb-2"
            src={uploadingImg}
          />
          <span className="text-orange-3">上传中...</span>
        </>
      )
    }
    if (status === 'success') {
      return <span className="text-red-2">上传成功!</span>
    }
    return ''
  }

  const uppyStyle = css`
    position: relative;
    display: flex;
    cursor: pointer;
    .uppy-DragDrop-container {
      width: 100px;
      height: 100px;
      background: rgba(0, 0, 0, 0.03);
      border-radius: 4px;
      &:focus {
        outline: none;
        box-shadow: 0 0 0 0 rgba($blue, 0.4);
      }
    }
    .uppy-DragDrop--isDragDropSupported {
      border: 0;
    }
    .uppy-DragDrop-inner {
      padding: 0;
    }
    .uppy-c-icon {
      display: none;
    }
    .uppy-StatusBar:before {
      height: 0;
    }
  `

  return (
    <>
      <div
        className={`${uppyStyle} ${slug}-uppy`}
        style={{
          height: '100px',
          width: '100px',
          background: 'rgba(0, 0, 0, 0.03)',
          borderRadius: '4px',
        }}
      >
        <div
          className="absolute z-10 px-5 w-full h-full text-white flex flex-col justify-center items-center text-sm"
          style={{ color: 'rgba(0,0,0,0.45)' }}
          onClick={() => {
            if (uploadStatus !== 'loading') {
              document
                .getElementsByClassName(`${slug}-uppy`)[0]
                .children[1].children[0].children[0].click()
            }
          }}
        >
          <img alt="" className="w-6 h-6 cursor-pointer" src={addImg} />
        </div>

        <DragDrop
          id={`${slug}-dragDrop`}
          className="z-20"
          uppy={uppy}
          locale={{
            strings: {
              dropHereOr: '',
            },
          }}
          height={100}
          width={100}
        />
      </div>
      {uploadStatus === 'loading' && (
        <div
          className="status-area flex flex-col items-center justify-center"
          style={{
            borderRadius: '4px',
            background: 'rgba(0,0,0,0.03)',
            fontSize: '.75rem',
          }}
        >
          <img
            alt=""
            className="status-icon cursor-pointer mb-2"
            src={uploadingImg}
          />
          <span className="text-primary">上传中...</span>
        </div>
      )}
    </>
  )
}

export default UploadFile
